<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >

          <!-- form -->
            <b-form
              class="auth-profile-form mt-2"
              @submit.prevent="updateProfile"
            >
              <!-- username -->
              <b-form-group
                label="First Name"
                label-for="profile-firstname"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Firstname"
                  vid="firstname"
                  rules="required"
                >
                  <b-form-input
                    disabled
                    id="profile-firstname"
                    :value="profile.first_name"                    
                    name="profile-firstname"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- username -->
              <b-form-group
                label="Last Name"
                label-for="profile-lastname"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Lastname"
                  vid="lastname"
                  rules="required"
                >
                  <b-form-input
                    disabled
                    id="profile-lastname"
                    :value="profile.last_name"                    
                    name="profile-lastname"
                    :state="errors.length > 0 ? false:null"
                    placeholder="doe"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- email -->
              <b-form-group
                label="Email"
                label-for="profile-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="profile-email"
                    :value="profile.email"
                    disabled
                    name="profile-email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- no api for update yet -->
            </b-form>                         
        </b-col>
    </b-row>      
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider } from 'vee-validate'
import {
  BRow, BCol, BForm, BFormGroup, BFormInput
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      username: '',
      userEmail: '',
      password: '',
      loading:false,
      // validation
      required,
      email,
    }
  },
  computed: {
    profile(){
      return this.$store.state.account.profile;
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    
  },
  methods: {
    updateProfile() {
      this.$refs.profileForm.validate().then(success => {
        if (success) {
        //   useJwt.profile(this.profile)
        //     .then(response => {
        //       //this.$ability.update(response.data.userData.ability)
        //       this.$router.push('/')
        //     })
        //     .catch(error => {
        //       this.$refs.profileForm.setErrors(error.response.data.error)
        //     })
        }
      })
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
